export const STYLES_NAME = {
    ACCORDION: 'ACCORDION',
    ADD_ORDER: 'ADD_ORDER_STYLES',
    AMOUNT_BULLET: 'AMOUNT_BULLET_STYLES',
    BACK_TO_TOP: 'BACK_TO_TOP_STYLES',
    BANNER: 'BANNER_STYLES',
    CARD_ROW_DETAIL: 'CARD_ROW_DETAIL_STYLES',
    CONFIRMATION_MESSAGE: 'CONFIRMATION_MESSAGE_STYLES',
    CONTAINER_WAVE: 'CONTAINER_WAVE_STYLES',
    DETAIL_CONFIRMATION: 'DETAIL_CONFIRMATION_STYLES',
    DETAIL: 'DETAIL_STYLES',
    DIVIDER: 'DIVIDER_STYLES',
    EMBEDDED_MESSAGE: 'EMBEDDED_MESSAGE_STYLES',
    EMPTY_STATUS: 'EMPTY_STATUS_STYLES',
    FIGURES: 'FIGURES_STYLES',
    FOOTER_ACTION: 'FOOTER_ACTION_STYLES',
    FOOTER_PAGE: 'FOOTER_PAGE_STYLES',
    GDPR: 'GDPR_STYLES',
    HEADER_CONSULTIVE: 'HEADER_CONSULTIVE_STYLES',
    HEADER_ONBOARDING: 'HEADER_ONBOARDING_STYLES',
    HEADER_OPERATIVE: 'HEADER_OPERATIVE_STYLES',
    HEADER_STEPPER: 'HEADER_STEPPER_STYLES',
    HEADER_WAVE: 'HEADER_WAVE_STYLES',
    HEADER: 'HEADER_STYLES',
    ICON: 'ICON_STYLES',
    IMAGES_STYLES: 'IMAGES_STYLES',
    INFO_CONTAINER: 'INFO_CONTAINER_STYLES',
    INPUT_OTP: 'INPUT_OTP_STYLES',
    INPUT_PHONE: 'INPUT_PHONE_CUSTOM_STYLES',
    INSTALMENT_PLAN: 'INSTALMENT_PLAN_STYLES',
    INSTALMENT_ROW: 'INSTALMENT_ROW_STYLES',
    LINE_SEPARATOR: 'LINE_SEPARATOR_L3_STYLES',
    MENU_ITEMS: 'MENU_ITEMS_STYLES',
    MENU_ONBOARDING: 'MENU_ONBOARDING',
    MENU_SIDEBAR_POSITION: 'MAIN_MENU_SIDEBAR_POSITION_STYLES',
    MENU_SIDEBAR: 'MENU_SIDEBAR_STYLES',
    MENU: 'MENU_STYLES',
    NAVBAR: 'NAVBAR_STYLES',
    NEXT_STEP: 'NEXT_STEP_STYLES',
    NEXT_STEPS: 'NEXT_STEPS_STYLES',
    OPERATIVE_CONTAINER: 'OPERATIVE_CONTAINER_STYLES',
    ORDERED_PARAGRAPH: 'ORDERED_PARAGRAPH_STYLES',
    OTP: 'OTP_STYLES',
    OVERVIEW_CARD_BNPL: 'OVERVIEW_CARD_BNPL_STYLES',
    OVERVIEW_CARD_ERROR: 'OVERVIEW_CARD_ERROR_STYLES',
    OVERVIEW_CARD_SKELETON: 'OVERVIEW_CARD_SKELETON_STYLES',
    PARAGRAPH: 'PARAGRAPH_STYLES',
    PAYBOX: 'PAYBOX_STYLES',
    PRODUCT_ROW: 'PRODUCT_ROW_STYLES',
    PROFILE: 'PROFILE_STYLES',
    RADIO_BUTTON_SELECTOR: 'RADIO_BUTTON_SELECTOR_STYLES',
    ROW_CHOICE: 'ROW_CHOICE_STYLES',
    SELECTOR_BOX_OPTION_CARD: 'SELECTOR_BOX_OPTION_CARD_STYLES',
    SELECTOR_CARD: 'SELECTOR_CARD_STYLES',
    TITLE: 'TITLE_STYLES',
    UPLOAD_DOC_TIPS: 'UPLOAD_DOC_TIPS_STYLES',
    WIZARD_STEPPER: 'WIZARD_STEPPER_STYLES',
};
//# sourceMappingURL=stylesName.js.map